<!-- global menu list -->
@if (isOpenMenu) {
  <section class="spen-ly-global-menu-list">
    <div class="menu-list-background" (click)="toggleMenu()"></div>
    <div class="menu-list-wrapper">
      <div class="spen-util-inner">
        @if (globalMenuData.length === 0) {
          <p>
            メニューの取得に失敗しました。ページの再読み込みを行なっていただくか、<a [href]="homeUrl">Classiトップ</a
            >のメニューをご利用ください。
          </p>
        }
        @for (menu of globalMenuData; track menu) {
          <div class="menu-item">
            <a class="menu-link" [href]="menu.link_url" [target]="menu.target_blank ? '_blank' : '_self'">
              <img class="menu-icon" [src]="menu.icon_url" /><br />
              @if (menu.batch) {
                <div class="spen-mod-circle-badge is-old-red">
                  <i class="fa fa-exclamation"></i>
                </div>
              }
              <div class="text" [innerHTML]="menu.title"></div>
            </a>
          </div>
        }
      </div>
    </div>
  </section>
}
